import { Injectable, inject } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { WebStorage } from "./web-storage";

@Injectable({
  providedIn: "root",
})
export class DocumentIdStorageService {
  private storage = inject(WebStorage);

  documentIDStorageSubject = new BehaviorSubject<boolean>(
    this.storage.documentID,
  );
  documentID$ = this.documentIDStorageSubject.asObservable();

  setDocumentId(documentIDValue: boolean) {
    this.storage.documentID = documentIDValue;
    this.documentIDStorageSubject.next(this.storage.documentID);
  }
}
